import { Box, SxProps } from '@mui/material';
import { FC } from 'react';
import PlaceIcon from '@mui/icons-material/Place';
import { keyframes } from '@emotion/react';

interface PinProps {
  sx?: SxProps;
  color?: string;
  size?: number;
  animate?: boolean;
  animationType?: 'bounce' | 'pulse';
}

const bounce = keyframes`
  0%, 100% {
    transform: translate(-50%, calc(-50% - 0px));
  }
  50% {
    transform: translate(-50%, calc(-50% - 5px)); 
  }
`;

const pulse = keyframes`
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
`;

export const Pin: FC<PinProps> = ({
  sx,
  color = 'primary.light',
  size = 48,
  animate = true,
  animationType = 'bounce',
}) => {
  const getAnimation = () => {
    if (animationType === 'bounce') {
      return `${bounce} 1s ease-in-out infinite`;
    } else if (animationType === 'pulse') {
      return `${pulse} 1s ease-in-out infinite`;
    }
    return undefined;
  };

  return (
    <Box
      sx={{
        color,
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: `translate(-50%, calc(-50% - ${size / 2}px))`,
        animation: animate ? getAnimation() : undefined,
        ...sx,
      }}
    >
      <PlaceIcon sx={{ fontSize: size }} />
    </Box>
  );
};
